export default "__VITE_ASSET__Bufno7hB__"